import * as YinzCam__LEI__LeicesterFooterAtom from "./Footer/LeicesterFooterAtom.svelte";

export const library = {
    YinzCam__LEI__LeicesterFooterAtom,
};